<template>
    <div class="container">
        <div class="row">
            <heading>{{ $t('admin_user.menuName') }}
                <template v-slot:actions>
                    <a href="/admin-user/create" class="btn btn-primary mr-2">{{ $t('core.actions.new') }}</a>
                    <a href="/admin-user?deactivated" class="btn btn-primary" v-if="$root.isSuperAdmin">{{ $t('admin_user.showDeactivated') }}</a>
                </template>
            </heading>
        </div>
        <div class="row">
            <div class="card col-12">
                <div class="card-body">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="border-top-0">{{ $t('admin_user.fields.username') }}</th>
                            <th class="border-top-0">{{ $t('admin_user.fields.email') }}</th>
                            <th class="border-top-0"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="user in users">
                            <td>{{ user.username }}</td>
                            <td>{{ user.email }}</td>
                            <td class="text-right">
                                <a :href="'/change-password/' + user.id" class="btn btn-sm btn-outline-primary">{{ $t('user.changePassword') }}</a>
                                <a class="btn btn-sm btn-outline-danger" :href="'/admin-user/' + user.id  + '/delete'" v-if="$root.isSuperAdmin && user.deleted_at === null">{{ $t('admin_user.delete') }}</a>
                                <a class="btn btn-sm btn-outline-danger" :href="'/admin-user/' + user.id  + '/restore'" v-if="$root.isSuperAdmin && user.deleted_at !== null">{{ $t('admin_user.activate') }}</a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AdminUserIndex',
        data: () => {
            return {
                users: lgt.users,
            }
        },
    }
</script>
